import { render, staticRenderFns } from "./Alt.vue?vue&type=template&id=1d73d1a2&scoped=true&"
import script from "./Alt.vue?vue&type=script&lang=js&"
export * from "./Alt.vue?vue&type=script&lang=js&"
import style0 from "./Alt.vue?vue&type=style&index=0&id=1d73d1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73d1a2",
  null
  
)

export default component.exports